module.exports = __webpack_public_path__ + "static/profil-052_optimized-c95de11a4ef6df752d731418377d09c0.jpg";